import { useEffect, useRef } from "react";
import cn from "classnames";
import Link from "next/link";
import i from "@styles/icons.module.scss";
import s from "./Button.module.scss";

const Button = ({
  iconLeft,
  iconRight,
  icon,
  to,
  flat,
  text,
  color,
  size = "m",
  children,
  disabled,
  className,
  type = "button",
  hoverEffect = true,
  canClickOnDisabled = false,
  ...props
}) => {
  const classes = cn(
    s.button,
    to && s.link,
    icon && s.icon,
    size && s[size],
    flat && s.flat,
    disabled && s.disabled,
    s[color],
    className
  );

  const buttonRef = useRef(null);

  useEffect(() => {
    const button = !disabled && !flat && buttonRef?.current;

    if (button) {
      const hover = (e) => {
        button.style.setProperty(
          "background-position",
          `${e.clientX - 60}px ${e.clientY - 60}px`
        );
      };

      button.addEventListener("mousemove", hover);

      return () => {
        button.removeAttribute("style");
        button.removeEventListener("mousemove", hover);
      };
    }
  }, [disabled, flat]);

  return to ? (
    <Link
      href={to}
      className={classes}
      ref={buttonRef}
      disabled={canClickOnDisabled ? false : disabled}
      {...props}
    >
      {iconLeft && <icon className={cn(i[`icon${iconLeft}`], s.iconLeft)} />}
      {icon ? (
        <icon className={cn(i[`icon${icon}`], s.icon)} />
      ) : (
        text || children
      )}
      {iconRight && <icon className={cn(i[`icon${iconRight}`], s.iconRight)} />}
    </Link>
  ) : (
    <button
      type={type}
      ref={buttonRef}
      className={classes}
      disabled={canClickOnDisabled ? false : disabled}
      {...props}
    >
      {iconLeft && <icon className={cn(i[`icon${iconLeft}`], s.iconLeft)} />}
      {icon ? (
        <icon className={cn(i[`icon${icon}`], s.icon)} />
      ) : (
        text || children
      )}
      {iconRight && <icon className={cn(i[`icon${iconRight}`], s.iconRight)} />}
    </button>
  );
};

export default Button;
